<div class="container bulk-style">
  <mat-card appearance="outlined">
    <mat-card-title>Upload spreadsheet to register cities</mat-card-title>

    <button
      mat-fab
      class="bulk-download-btn"
      (click)="downloadCitySampleFile()"
      [disabled]="!isAdminGroupUser"
      [ngClass]="
        isAdminGroupUser
          ? 'mat-mini-fab mat-accent'
          : 'mat-mini-fab mat-button-disabled'
      "
      color="accent"
      matTooltip="Download Sample Spreadsheet for Cities"
    >
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size: 30px">download</i>
      </span>
    </button>

    <mat-card-subtitle></mat-card-subtitle>

    <mat-card-content>
      <div class="col-md-12 form-group">
        <div class="instruction-box">
          <ul class="instruction-list">
            <li>
              You can upload an Excel file to create cities;
              <span class="highlight">limit is 250 rows</span> per upload.
            </li>
            <li>
              Make sure only the <span class="highlight">first sheet</span> contains data;
              others are ignored.
            </li>
            <li>
              Do <span class="highlight">not rename</span> the sheet;
              use it for city information only.
            </li>
            <li>
              <span class="highlight">Avoid changing</span> the column headers;
              always refer to the latest template.
            </li>
            <li>
              Acceptable values must match those from the
              <span class="highlight">provided sample</span> for
              <span class="highlight">State and Country</span> fields.
            </li>
            <li>
              Contact the admin if reference data is unavailable or outdated.
            </li>
            <li>
              Use the <span class="highlight">Download</span> button above
              to get the format. Post-upload, a report will be downloaded.
            </li>
            <li>
              Please make sure you are uploading a .xlsx format.
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 form-group">
          <div class="fake-wrapper">
            <input
              type="file"
              class="form-control"
              [disabled]="!isAdminGroupUser"
              (change)="onCityFileUpload($event)"
              placeholder="Choose file"
            />
          </div>
        </div>
      </div>

      <div
        *ngIf="isLoaderResult"
        class="loader"> 
        <mat-spinner color="warn"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>
